import React from 'react';

function Assistance() {
  return (
    <>
      {/* ASSISTANCE + NEWSLETTER */}
<section className="assist-section" id="assist">
  <div className="assist-inner">
    <div className="animate-on-scroll">
      <div className="section-eyebrow assist-eyebrow">Need Assistance?</div>
      <h2 className="section-h2 assist-h2">Our team is here<br />to guide you.</h2>
      <p className="section-lead assist-lead">Our team is available to guide you through integration and security protocols or address any fraud-related concerns.</p>
      <div className="assist-cards">
        <div className="assist-card"><div className="assist-icon-wrap"><svg className="sv-icon" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" ><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.64 1.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.83a16 16 0 0 0 5.45 5.45l1.22-.98a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg></div><div className="assist-card-title">Contact Support</div><a href="https://speedvault.in/contact_us">Talk to our team →</a></div>
        <div className="assist-card"><div className="assist-icon-wrap"><svg className="sv-icon" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" ><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v2z"/></svg></div><div className="assist-card-title">Submit a Ticket</div><a href="https://speedvault.in/ticket">Open a request →</a></div>
      </div>
    </div>
    <div className="nl-box animate-on-scroll" style={{transitionDelay: '.15s'}}>
      <div className="nl-h3">Get the Latest in<br />Digital Payments.</div>
      <p className="nl-p">Subscribe to our newsletter for the newest trends, updates, and insights on UPI solutions and digital payment technologies.</p>
      <div className="nl-row">
        <input className="nl-input" type="email" placeholder="your@email.com" />
        <button className="nl-btn">Subscribe Now</button>
      </div>
    </div>
  </div>
</section>
    </>
  );
}

export default Assistance;
